<template>
  <div>
    <div class="mb-5" v-if="!onlyReferees">
      <FootballLeagueTimetable :extraLeagueId="+leagueId"
                               extra-country-query-name="''"
                               extra-country-name="''"
                               :matchesAmount="10"
                               :is-referee="true">
      </FootballLeagueTimetable>
    </div>
    <div class="mb-5 rounded-zt border-[1px] border-zt-light overflow-hidden">
      <div v-if="onlyReferees && league !== []" class="flex border-b border-zt-light gap-x-[7px] text-xs font-normal -leading-[0.18px] bg-zt-light-full px-[15px] py-2.5 w-full">
        <a class="cursor-pointer zt-hover no-default-style flex" :href="`/wyniki-pilka-nozna/${league.country_query_name}/${league.query_name}/`">
          <div class="w-[15px] h-[11px] mt-[2px] py-auto">
            <img ref="CountryImg" class="w-full h-full rounded-[2px]"
                 :src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name?.toLowerCase()}.svg`"
                 :alt="league.country_name">
          </div>
          <span class="ml-1">{{ league.country_polish_name }}: {{league.name}}</span>
        </a>
      </div>
      <div class="flex justify-center bg-zt-light-opacity rounded-t-zt" :class="{'!rounded-t-none' : onlyReferees}">
        <button class="my-2.5 py-2 text-center border-[1px] rounded-l-zt w-[120px] border-zt-light text-xs !border-b-none"
                id="teams" :class="{'bg-zt-light' : sortType === 'sum'}" @click="sortType = 'sum'">
          SUMA
        </button>
        <button class="my-2.5 py-1 text-center border-[1px] rounded-r-zt w-[120px] border-zt-light text-xs"
                id="referees" :class="{'bg-zt-light' : sortType === 'avg'}" @click="sortType = 'avg'">
          ŚREDNIA
        </button>
      </div>
      <table class="w-full">
        <tr class="border-t bg-zt-light-full text-xs border-b border-zt-light">
          <th class="pl-2.5 pr-2 !w-[10px] h-[38px] text-left font-medium uppercase">L.P</th>
          <th class="pr-2 h-[38px] text-left font-medium uppercase pl-1">Sędzia</th>
          <th class="text-center whitespace-pre shrink-0 cursor-pointer zt-hover font-medium !w-[38px] underline xl:basis-12 xl:!w-[40px]"
              v-for="(column, index) of columns" @click="sortTable(column, $event)">
            <div>
              {{ column }}
            </div>
          </th>
        </tr>
        <tr v-for="(referee, index) in refereeStats" class="px-4 border-t bg-zt-light-opacity text-xs border-b border-zt-light
          text-center last:!border-b-[0px]">
          <td class="pl-2.5 h-[38px] !text-left font-medium uppercase font-['Lato'] text-[13px]"><span>{{ index + 1 }}.</span></td>
          <td class="!text-left opacity-70 pl-1 text-[13px]">{{ referee.name?.split(',')[0].trim() }}</td>
          <td :class="{'bg-zt-light-full' : sortColumn === 'M'}" class="font-['Lato']">{{ referee.matches.length }}</td>
          <td :class="{'bg-zt-light-full' : sortColumn === 'K'}" class="font-['Lato']">{{ sortType === 'avg' ?  (referee.penalties/referee.matches.length).toFixed(2) : referee.penalties }}</td>
          <td :class="{'bg-zt-light-full' : sortColumn === 'Ż.K.'}" class="font-['Lato']">{{ sortType === 'avg' ? (referee.yellow_cards/referee.matches.length).toFixed(2) : referee.yellow_cards }}</td>
          <td :class="{'bg-zt-light-full' : sortColumn === 'CZ.K.'}" class="font-['Lato']">{{ sortType === 'avg' ? (referee.red_cards/referee.matches.length).toFixed(2) : referee.red_cards }}</td>
        </tr>
      </table>
      <div class="pl-4 py-3 bg-zt-light/35 rounded-b-zt border-t-[1px] border-zt-light text-zt-more text-xs">
        <div class="w-full">M - Mecze</div>
        <div class="w-full">K - Karne</div>
        <div class="w-full">Ż.K - Żółte kartki</div>
        <div class="w-full">CZ.K - Czerwone kartki</div>
      </div>
    </div>
  </div>
</template>

<script>
import {useStatsStore} from "../../../stores/StatsStore";
import football_mixin from "../../../mixins/football_mixin";
import utils_mixin from "../../../mixins/utils_mixin";
import FootballLeagueTimetable from "../../../sections/FootballLeagueTimetable.vue";

export default {
  name: "RefereeDetailsTable",
  inject: ['WP'],
  mixins: [football_mixin, utils_mixin],
  components: {
    FootballLeagueTimetable
  },
  setup() {
    const statsStore = useStatsStore();
    return { statsStore };
  },
  props: {
    leagueId: {
      type: Number,
      default: -1
    },
    onlyReferees: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortAscending: 0,
      sortColumn: 'Ż.K.',
      sortType: 'sum',
      columns: ['M', 'K', 'Ż.K.', 'CZ.K.'],
      matches: [],
      league: [],
    }
  },
  mounted() {
    this.statsStore.getRefereeStats(+this.leagueId);
    if (this.onlyReferees) {
      this.getLeagueDetails();
    }
  },
  computed: {
    refereeStats() {
      if (this.statsStore.refereeStats[+this.leagueId] === undefined) {
        return [];
      }
      return this.statsStore.refereeStats[+this.leagueId].slice().sort(this.sortReferees);
    },
  },
  methods: {
    sortReferees(a, b) {
      let diff = 0;
      if (this.sortAscending) {
        switch (this.sortColumn) {
          case 'M':
            diff = +a.matches.length - +b.matches.length;
            break;
          case 'Ż.K.':
            if (this.sortType === 'sum') {
              diff = a.yellow_cards - b.yellow_cards;
            } else {
              diff = a.yellow_cards/a.matches.length - b.yellow_cards/b.matches.length;
            }
            break;
          case 'CZ.K.':
            if (this.sortType === 'sum') {
              diff = a.red_cards - b.red_cards;
            } else {
              diff = a.red_cards/a.matches.length - b.red_cards/b.matches.length;
            }
            break;
          case 'K':
            if (this.sortType === 'sum') {
              diff = a.penalties - b.penalties;
            } else {
              diff = a.penalties/a.matches.length - b.penalties/b.matches.length;
            }
            break;
        }
      } else {
        switch (this.sortColumn) {
          case 'M':
            diff = b.matches.length - a.matches.length;
            break;
          case 'Ż.K.':
            if (this.sortType === 'sum') {
              diff = b.yellow_cards - a.yellow_cards;
            } else {
              diff = b.yellow_cards/b.matches.length - a.yellow_cards/a.matches.length;
            }
            break;
          case 'CZ.K.':
            if (this.sortType === 'sum') {
              diff = b.red_cards - a.red_cards;
            } else {
              diff = b.red_cards/b.matches.length - a.red_cards/a.matches.length;
            }
            break;
          case 'K':
            if (this.sortType === 'sum') {
              diff = b.penalties - a.penalties;
            } else {
              diff = b.penalties/b.matches.length - a.penalties/a.matches.length;
            }
            break;
        }
      }
      return diff;
    },
    getLeagueDetails() {
      axios
      .post(this.WP.ajaxUrl, {
        endpoint: 'api_get_league_details',
        league_id: this.leagueId
      })
      .then(res => {
        this.league = res.data.data;
      })
    }
  }
}
</script>

<style scoped>

</style>